/*
 * Filename: c:\Users\aasan_95ppk60\OneDrive\Documents\College\git\usocial-r\USocial-R\usocial-app\src\context\AuthContext.js
 * Path: c:\Users\aasan_95ppk60\OneDrive\Documents\College\git\usocial-r\USocial-R\usocial-app
 * Created Date: Saturday, December 9th 2023, 3:07:45 pm
 * Author: Alejandro Santiago
 * 
 * Copyright (c) 2023 
 */
import { onAuthStateChanged } from "firebase/auth";
import { createContext, useEffect, useState } from "react";
import { auth } from '../firebase';

export const AuthContext = createContext()

export const AuthContextProvider = ({children}) => {
    const [currentUser, setCurrentUser] = useState({});

    useEffect(()=>{
        const unsub = onAuthStateChanged(auth, (user) =>{
            setCurrentUser(user)
            console.log(user)
        });


        return () =>{
            unsub();
        };
    }, []);


return(
<AuthContext.Provider value = {{currentUser}}>
    {children}
</AuthContext.Provider>
);
};